var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 266 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.553 178.349L178.821 185.754C178.821 185.754 162.823 203.358 119.155 155.308C75.4866 107.259 91.4847 89.6563 91.4847 89.6563L95.7229 84.9926C106.165 73.504 107.149 55.059 98.0386 41.5934L79.4047 14.0485C68.1296 -2.61784 46.3424 -4.81944 33.4191 9.40013L10.224 34.9221C3.81604 41.9728 -0.478087 51.1127 0.0426811 61.2519C1.3749 87.1911 11.9805 143.002 71.1602 208.118C133.918 277.17 192.802 279.914 216.883 277.43C224.499 276.645 231.123 272.352 236.46 266.478L257.454 243.381C271.624 227.789 267.628 201.058 249.497 190.152L221.264 173.168C209.359 166.007 194.857 168.11 185.553 178.349Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fbd29cd48a5f82c2f2f72b3463166dff.svg";
export { ForwardRef as ReactComponent };